import { useEffect, useState } from "react";
import { Loader2, Phone, CalendarDays, Clock, Home, FileText } from "lucide-react";
import { api, fmtDate, waLink } from "@/lib/api";
import { WhatsAppIcon } from "@/components/WhatsAppFloat";

const Chip = ({ icon: Icon, children }) => (
  <span className="flex items-center gap-1.5 rounded-full border border-gold/20 bg-ink/60 px-3 py-1.5 text-xs text-ivory/85">
    {Icon && <Icon size={12} className="text-gold-subtle" />} {children}
  </span>
);

const VisitsTab = () => {
  const [bookings, setBookings] = useState(null);

  useEffect(() => {
    api
      .get("/admin/bookings")
      .then((r) => setBookings(r.data))
      .catch(() => setBookings([]));
  }, []);

  return (
    <div>
      <h2 className="font-serif text-2xl text-ivory">Reservas de visitas</h2>
      {bookings === null && (
        <div className="mt-10 flex justify-center">
          <Loader2 className="animate-spin text-gold" size={28} />
        </div>
      )}
      {bookings && bookings.length === 0 && (
        <p className="mt-10 rounded-xl border border-gold/15 bg-ink2/60 p-8 text-center text-stone2" data-testid="admin-bookings-empty">
          Todavía no hay reservas. Cuando alguien reserve una visita sin presencia desde tu enlace, aparecerá aquí.
        </p>
      )}
      <div className="mt-6 space-y-4">
        {bookings &&
          bookings.map((b) => (
            <div key={b.id} data-testid={`booking-card-${b.id}`} className="rounded-xl border border-gold/15 bg-ink2/70 p-5">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <p className="font-medium text-ivory">
                  {b.name} <span className="text-xs text-stone2">· {fmtDate(b.created_at)}</span>
                </p>
                <div className="flex gap-2">
                  <a href={`tel:${b.phone}`} data-testid={`booking-phone-${b.id}`} className="flex items-center gap-1.5 rounded-full border border-gold/25 px-3.5 py-1.5 text-xs text-gold hover:bg-gold/10">
                    <Phone size={12} /> {b.phone}
                  </a>
                  <a
                    href={waLink(`Hola ${b.name.split(" ")[0]}, soy Inmobiliaria Tecnohogar. Confirmo tu visita sin presencia para el ${b.date || "día acordado"} a las ${b.time || "hora acordada"}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`booking-whatsapp-${b.id}`}
                    className="flex items-center gap-1.5 rounded-full bg-wa/15 px-3.5 py-1.5 text-xs text-wa hover:bg-wa/25"
                  >
                    <WhatsAppIcon className="h-3.5 w-3.5" /> Confirmar
                  </a>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                {b.property_ref && <Chip icon={Home}>{b.property_ref}</Chip>}
                {b.date && <Chip icon={CalendarDays}>{b.date}</Chip>}
                {b.time && <Chip icon={Clock}>{b.time}</Chip>}
              </div>
              {b.notes && <p className="mt-3 whitespace-pre-line rounded-lg bg-ink/60 p-4 text-sm leading-relaxed text-ivory/85">{b.notes}</p>}
            </div>
          ))}
      </div>
    </div>
  );
};

export default VisitsTab;
